import { FormLabelRAC, Link, Text } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { PropsWithChildren, useContext } from "react";
import Markdown from "react-markdown";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { handleMissingAndBlankData } from "../utils";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

function MarkdownControl(props: CascadiaControlProps) {
  const options = props.uischema?.options || {};
  let markdown = options.markdown;
  const placeholders: object = options.placeholders || {};

  const { isSummaryForPath } = useContext(CascadiaJsonFormContext);

  if (isSummaryForPath?.(props.path) && !options.renderIfSummary) {
    return null;
  }

  // process placeholders
  Object.entries(placeholders).forEach(([placeholderKey, placeholderValue]) => {
    let data;
    if (placeholderValue.substring(0, 1) === "#") {
      // get data key from scope
      // ie: get "sources" from #/properties/sources
      const key = placeholderValue.split("/").pop();
      data = handleMissingAndBlankData(props.data[key]);
    } else {
      data = handleMissingAndBlankData(placeholderValue);
    }
    markdown = markdown.replaceAll("${" + placeholderKey + "}", data);
  });

  // if there is no markdown, just use the data
  if (markdown === undefined) markdown = props.data.toString();

  const textWrapper = (props: PropsWithChildren) => {
    return (
      <Text
        style={options.textStyle || "global/body-primary"}
        testID={options.testId || "text"}
      >
        {props.children}
      </Text>
    );
  };
  return (
    <div>
      {props.uischema?.label && (
        <FormLabelRAC isRequired>{props.label}</FormLabelRAC>
      )}
      <Markdown
        className={css({
          display: "flex",
          flexDirection: "column",
          rowGap: "var(--space-4)",
          ...(options.styles || {}),
        })}
        components={{
          p: textWrapper,
          a: (props) => {
            return (
              <Link
                href={props.href}
                target="_blank"
                testID="markdown-link"
                linkStyle="monochrome"
              >
                {props.children}
              </Link>
            );
          },
        }}
      >
        {markdown}
      </Markdown>
    </div>
  );
}

MarkdownControl.displayName = "MarkdownControl";

export const MarkdownControlRenderer =
  withCascadiaControlProps(MarkdownControl);
